module.exports = __webpack_public_path__ + "img/555.da6097a7.png";